export default __webpack_public_path__ + "static/media/our-services-section-three-arrow-right.d6d6c165.svg";